import { Suspense, useEffect } from "react";
import PropTypes from "prop-types";
import { retryLazy } from "@claroty/utilities/asyncUtils";
import { withRouter } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import { isNullOrUndefined } from "../utils/generalUtils";
import { initBrandCssSkin } from "../utils/infra/productVerticalUtils";
import ConnectedConfirmationDialog from "./common/ConfirmationDialog/ConnectedConfirmationDialog";
import ConnectedDialog from "./common/Dialog/ConnectedDialog";
import ErrorBoundary from "./common/ErrorBoundary/ErrorBoundary";
import ConnectedLoadingContainer from "./common/LoadingContainer/ConnectedLoadingContainer";
import PreAuthApp from "./PreAuthApp";
import AppAnalyticsHelper from "./app/AppAnalyticsHelper";
import NewAppVersion from "./app/NewAppVersion/NewAppVersion";
import { AUTO_CLOSE_SECONDS } from "./app/Notifications/notifications";

// Lazy components
const App = retryLazy(() => import("./App"));

const BaseApp = ({ isAuthenticated, location, onLogin }) => {
    // initial app loading
    const isLoadingAuthentication = isNullOrUndefined(isAuthenticated);

    useEffect(() => {
        initBrandCssSkin();
    }, []);

    let app = null;
    if (!isLoadingAuthentication) {
        app = isAuthenticated ? (
            <Suspense fallback={null}>
                <App />
            </Suspense>
        ) : (
            <PreAuthApp onLogin={onLogin} />
        );
    }

    return (
        <ErrorBoundary section="app">
            <AppAnalyticsHelper location={location} />
            <ConnectedLoadingContainer />
            <ConnectedConfirmationDialog />
            <ConnectedDialog />
            <NewAppVersion />
            <ToastContainer
                position="bottom-right"
                autoClose={AUTO_CLOSE_SECONDS * 1000}
                newestOnTop={false}
                rtl={false}
                draggable={true}
                pauseOnHover={true}
                transition={Slide}
            />
            {app}
        </ErrorBoundary>
    );
};

BaseApp.propTypes = {
    isAuthenticated: PropTypes.bool,
    location: PropTypes.object.isRequired,
    onLogin: PropTypes.func.isRequired,
};

export default withRouter(BaseApp);
